import styles from './styles.module.scss';

export const H3 = props => <h3 className={styles.h3}>{props.children}</h3>;
export const H2 = props => (
  <h2
    className={styles.h2}
    style={{
      fontSize: props.customSize,
      lineHeight: props.customSize ? `${props.customSize + 10}px` : undefined,
    }}
  >
    {props.children}
  </h2>
);
export const H1 = props => <h1 className={styles.h1}>{props.children}</h1>;
